export class KappaType {
  public id?: number
  public kappaType1?: string
  public description?: string
  public isShownInReportUI?: boolean
  public isReportDefault?: boolean

  //constructor(
  //  public id?: number,
  //  public kappaType1?: string,
  //  public description?: string,
  //  public IsShownInReportUI?: boolean,
  //  public IsReportDefault?: boolean) { }
}
